import React from 'react';
import ReactDOM from 'react-dom';
import App from './app';
// import { GeneralProvider } from './context/generalContext.jsx'

ReactDOM.render(
    // <GeneralProvider>
        <App />
    // </GeneralProvider>
    ,
    document.getElementById('root')
);

